var Cookies = require('js-cookie');
var AcSection = /** @class */ (function () {
    function AcSection(el) {
        this.element = el;
        this.init();
    }
    AcSection.prototype.init = function () {
        var _this = this;
        if (this.element.classList.contains('-closable')) {
            var header = this.element.querySelector('.ac-section__header');
            if (header) {
                header.addEventListener('click', function () {
                    _this.toggle();
                });
            }
            if (this.isStorable()) {
                var setting = Cookies.get(this.getCookieKey());
                if (setting !== undefined) {
                    (parseInt(setting) === 1) ? this.open : this.close();
                }
            }
        }
    };
    AcSection.prototype.getCookieKey = function () {
        return "ac-section_" + this.getSectionId();
    };
    AcSection.prototype.getSectionId = function () {
        return this.element.dataset.section;
    };
    AcSection.prototype.isStorable = function () {
        return typeof this.element.dataset.section !== 'undefined';
    };
    AcSection.prototype.toggle = function () {
        this.isOpen() ? this.close() : this.open();
    };
    AcSection.prototype.isOpen = function () {
        return !this.element.classList.contains('-closed');
    };
    AcSection.prototype.open = function () {
        this.element.classList.remove('-closed');
        if (this.isStorable()) {
            Cookies.set(this.getCookieKey(), 1);
        }
    };
    AcSection.prototype.close = function () {
        this.element.classList.add('-closed');
        if (this.isStorable()) {
            Cookies.set(this.getCookieKey(), 0);
        }
    };
    return AcSection;
}());
export default AcSection;
